import { render } from "./UpcomingCourseNotification.vue?vue&type=template&id=0d13ec19&scoped=true"
import script from "./UpcomingCourseNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./UpcomingCourseNotification.vue?vue&type=script&setup=true&lang=js"

import "./UpcomingCourseNotification.vue?vue&type=style&index=0&id=0d13ec19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d13ec19"],['__file',"src/components/notifications/UpcomingCourseNotification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d13ec19"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d13ec19', __exports__)) {
    api.reload('0d13ec19', __exports__)
  }
  
  module.hot.accept("./UpcomingCourseNotification.vue?vue&type=template&id=0d13ec19&scoped=true", () => {
    api.rerender('0d13ec19', render)
  })

}


export default __exports__